import axios from 'axios';
import JustValidate from 'just-validate';
import utils from './functions-base/utils';
import validateCode from './forgot-password/validate-code';

declare let core_object: any;
declare let auth_object: any;

// Utils
const modUtils = new utils();

export default class authForgotpassword{

    protected elWrapForm: string;
    protected elForm: string;
    protected elFormAlert: string;
    protected elFormBtn: string;
    protected elFormCode: string;
    protected elFormCodeBtn: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_forgot_password: string;
    protected url_api_validate_code: string;
    protected modValidateCode: validateCode;

    /**
     * Constructor
     * @param elWrapForm
     * @param elForm 
     * @param elFormAlert 
     * @param elFormBtn 
     * @param elFormCode
     * @param elFormCodeBtn
     */
    constructor(
        elWrapForm: string,
        elForm: string,
        elFormAlert: string,
        elFormBtn: string,
        elFormCode: string,
        elFormCodeBtn: string
    ){

        this.elWrapForm = elWrapForm;
        this.elForm = elForm;
        this.elFormAlert = elFormAlert;
        this.elFormBtn = elFormBtn;
        this.elFormCode = elFormCode;
        this.elFormCodeBtn = elFormCodeBtn;
        this.url_api_forgot_password = auth_object.rest_urls.auth_forgot_password;
        this.url_api_validate_code = auth_object.rest_urls.auth_validate_code;

        // Validate code
        this.modValidateCode = new validateCode(
            this.elWrapForm,
            this.elFormCode,
            this.elFormAlert,
            this.elFormBtn
        );

    }

    /**
     * Init form
     */
    initForm(){
        
        const _that = this;

        const form = document.querySelector(_that.elForm) as HTMLElement | null;

        if(form !== null){

            // Validate mail
            _that.validateMail();

        }
        
    }

    /**
     * Validation mail
     * @returns 
     */
    protected validateMail(){
        
        const _that = this;

        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid border border-red-300',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1 !text-red-300',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#auth_email', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.email_required,
            },
            {
                rule: 'email',
                errorMessage: auth_object.error_messages.email_invalid,
            },
        ])
        .onSuccess((event: any) => {
                
                event.preventDefault();
            
                _that.sendApi(event?.currentTarget);
                
        });

        return validation;

    }

    /**
     * Send api
     * @param form
     */
    protected sendApi(form: HTMLFormElement) {
        
        const _that = this;

        // Wrap form
        const wrap_form = document.querySelector(_that.elWrapForm) as HTMLElement | null;

        // Get form data
        const data = new FormData(form); 
        
        // Conver form data to string
        const datastring = new URLSearchParams(data as any).toString();

        // Button
        const btn = document.querySelector(this.elFormBtn) as HTMLButtonElement | null;

        // Init post data
        const post_data = {
            ajax_nonce: core_object.ajaxNonce,
            'fields': datastring
        };

        // Create query string
        const queryString = new URLSearchParams(post_data).toString();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Init spin
        const spin = modUtils.btnSpin(this.elFormSpin);

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(_that.url_api_forgot_password, queryString)
            .then(function (response: any) {

            // Remove alert box
            modUtils.removeAlertBox(
                _that.elForm,
                _that.elFormAlert
            );

            // Remove spin
            spin.remove();
                
            // Remove disabled attribute
            btn?.removeAttribute('disabled');

            const responseStatus: boolean = response.data.status;
                
            // True
            if(responseStatus == true){
                
                form.remove();
                
                const getTemplate = response.data.template as string;

                // Append Template
                wrap_form?.insertAdjacentHTML('afterbegin', getTemplate);

                // Validate form code
                const validation = _that.modValidateCode.validate();

            }

            // False
            if(responseStatus == false){
                
                // Get errors
                const errors = response.data.errors;
                
                if(Array.isArray(errors)){
                    
                    errors.forEach(function(error){
                        
                        let alert = modUtils.alertBox(
                            _that.elFormAlert,
                            auth_object.general_message.error,
                            error
                        );
                        form.prepend(alert);

                    });

                }else{
                    
                    const alert = modUtils.alertBox(
                        _that.elFormAlert,
                        auth_object.general_message.error,
                        errors
                    );
                    form.prepend(alert);

                }
  
            }

        })
        .catch(function (error:any){

            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');

        });

    }
    
}